import { useEffect } from "react";
import { X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, Spinner } from "reactstrap";
import Cookies from "js-cookie";

import VideoDetails from "./VideoDetails";
import MainThumbnail from "./MainThumbnail";
import { fetchAutoCompleteProductOrHashtagList } from "../../Pages/Product/productActions";

const Step2FetchDetails = ({
  open,
  savedLoading,
  productsOption,
  singleVideoDetail,
  handleClose,
  updateSwitch,
  handleSuccess,
  onChangeNotes,
  updateVideoTags,
  ShouldNextEnable,
  handleChangeProduct,
  selectCompetitors,
  handleTagsInputChange,
  handleChangeCategory,
  stepBackHandler,
}) => {
  const { errors } = useSelector((state) => state);
  const { validationErrors } = errors;
  const { platform } = singleVideoDetail;
  const { addCompetitorVideo } = useSelector((state) => state.videoData);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      fetchAutoCompleteProductOrHashtagList({
        is_hashtag: false,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
      })
    );
  }, []);
  const SwitchFilter = ({ fieldText, value, name }) => (
    <div
      className="d-flex align-items-center"
      style={{ gap: "16px", marginBottom: "5px" }}
    >
      <input
        type="checkbox"
        value={value}
        name={name}
        checked={value}
        onChange={updateSwitch}
        style={{
          width: "16px",
          height: "16px",
          accentColor: "#6c757d",
          cursor: "pointer",
        }}
      />
      <span style={{ fontSize: "14px", color: "#000" }}>{fieldText}</span>
    </div>
  );
  return (
    <Modal
      size="lg"
      style={{ maxWidth: "1336px" }}
      isOpen={open}
      toggle={() => handleClose(!open, "step2Modal")}
      className="Step2FetchDetails VideoProcess modal-dialog-centered"
    >
      <ModalBody style={{ height: "677px" }}>
        <div className="ModalContainer">
          <div
            className="d-flex justify-content-between"
            style={{ marginBottom: "25px" }}
          >
            <div className="videoTitle">
              <h1 style={{ lineHeight: "160%" }}>{singleVideoDetail.title}</h1>
            </div>
            <X
              style={{ position: "absolute", top: "57px", right: "31px" }}
              size={50}
              color="black"
              strokeWidth={1}
              role="button"
              onClick={() => {
                handleClose(!open, "step2Modal");
              }}
            />
          </div>

          <div className="d-flex" style={{ marginBottom: "32px", gap: "58px" }}>
            <div>
              <MainThumbnail
                selectedImage={singleVideoDetail.thumbnail_url}
                singleVideoDetail={singleVideoDetail}
              />
            </div>
            <div style={{ width: "50%" }}>
              <div className="VideoDetailContainer">
                <VideoDetails
                  singleVideoDetail={singleVideoDetail}
                  handleChangeProduct={handleChangeProduct}
                  selectCompetitors={selectCompetitors}
                  productsOption={productsOption}
                  handleTagsInputChange={handleTagsInputChange}
                  updateVideoTags={updateVideoTags}
                  onChangeNotes={onChangeNotes}
                  validationErrors={validationErrors}
                  handleChangeCategory={handleChangeCategory}
                />
              </div>
            </div>
          </div>

          {!singleVideoDetail.enableNext && (
            <div
              className="d-flex justify-content-center"
              style={{ marginTop: "69px" }}
            >
              <Button
                size="lg"
                className="video-process-btn"
                color="primary"
                onClick={() => ShouldNextEnable(true)}
              >
                Next
              </Button>
            </div>
          )}

          {singleVideoDetail.enableNext && (
            <>
              {" "}
              <div
                style={{
                  color: "black",
                  fontSize: "14px",
                  fontWeight: "700",
                  margin: "51px 0px 2px 0px",
                }}
              >
                Select the Video Type
              </div>
              <div className="d-flex gap-3" style={{ height: "70px" }}>
                {!addCompetitorVideo && (
                  <div
                    className="d-flex gap-5 align-items-center"
                    style={{ width: "47%" }}
                  >
                    {SwitchFilter({
                      fieldText: "Verified Shopper",
                      value: singleVideoDetail.is_paid_or_sponsored,
                      name: "is_paid_or_sponsored",
                    })}
                    <span>
                      {SwitchFilter({
                        fieldText: "Brand Video",
                        value: singleVideoDetail.is_advertisement,
                        name: "is_advertisement",
                      })}{" "}
                    </span>
                  </div>
                )}

                <div
                  className={`d-flex align-items-center justify-content-center ${
                    addCompetitorVideo ? "w-100" : "w-50"
                  }`}
                  style={{ marginTop: "-40px", marginLeft: "80px" }}
                >
                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <Button
                      size="lg"
                      className="video-process-btn"
                      color="outline-primary"
                      onClick={() => {
                        stepBackHandler();
                      }}
                      style={{ right: "310px", width: "178px", height: "56px" }}
                    >
                      Back
                    </Button>

                    <Button
                      size="lg"
                      className="video-process-btn"
                      color="primary"
                      onClick={handleSuccess}
                      style={{ width: "178px", height: "56px" }}
                      disabled={savedLoading}
                    >
                      <span className="d-flex justify-content-center align-items-center gap-1">
                        Save {savedLoading && <Spinner size="sm" />}
                      </span>
                    </Button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Step2FetchDetails;
